<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_ii"></a><a id="page_iii"></a><span class="bold">StuG III Brigade 191, 1940–1945</span></h1>
<p class="stitle">The Buffalo Brigade in Action in the Balkans,</p>
<p class="stitle0">Greece and from Moscow to</p>
<p class="stitle0">Kursk and Sevastopol</p>
<p class="author1"><span class="bold">Bruno Bork</span></p>
<p class="author2"><span class="bold">Foreword by Anthony Tucker-Jones</span></p>
<div class="img_container1">
<img alt="Images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?1715861e